<template>
    <div v-show="visible">
        <el-dialog title="自定义输出报告" :close-on-click-modal="false"
            v-loading="loading"
            :element-loading-text="loadingText"
            :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item prop="reportType" label="报告分类">
                    <el-select v-model="form.reportType"
                        :disabled="!form.buttonType == 2"
                        clearable placeholder="请选择" style="width: 150px;">
                        <el-option
                            v-for="item in reportTypes"
                            :key="item.operaType"
                            :label="item.name"
                            :value="item.operaType">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="beginDate" label="开始日期">
                    <el-date-picker
                        :disabled="!form.buttonType == 2"
                        v-model="form.beginDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 150px;"
                        type="date"
                        placeholder="开始日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item  prop="endDate" label="结束日期">
                    <el-date-picker
                        :disabled="!form.buttonType == 2"
                        v-model="form.endDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 150px;"
                        type="date"
                        placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save()" v-if="form.buttonType == 1">生成校长报告</el-button>
                <el-button type="primary" @click="download()" v-if="form.buttonType == 2">下载校长报告</el-button>
                <el-button @click="visible=false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../../common/http'; 

    export default {
        data(){
            return{
                loading:false,
                loadingText:"",
                visible: false,
                form:{
                    deptId: "",
                    reportType: "",
                    startDate: "",
                    endDate: "",
                    buttonType: 1
                },
                reportTypes:[],
                reportUrl: "",
                rules: {
                    reportType: [
                        { required: true, message: '请选择报告分类', trigger: 'blur' }
                    ],
                    beginDate: [
                        { required: true, message: '请选择开始日期', trigger: 'blur' }
                    ],
                    endDate: [
                        { required: true, message: '请选择结束日期', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(deptId){
                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.form.buttonType = 1
                this.form.deptId=deptId
                this.customGenerateReportType()
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 自定义生成报告分类
            customGenerateReportType(){
                let url= this.headmasterReportCustomGenerateReportTypeUrl;
                let data = {
                    deptId:this.form.deptId,
                };
                // console.log(JSON.stringify(data));
                // return;
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.reportTypes = res.data
                        console.log('test', this.reportTypes)
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        let gradeNames =""
                        let operaType=""
                        // gradeNames 年级名称
                        // operaType 操作类型
                        for(let i=0; i<this.reportTypes.length;i++){
                            let tempOperaType = this.reportTypes[i].operaType
                            if(tempOperaType == this.form.reportType){
                                gradeNames = this.reportTypes[i].gradeNames
                                operaType = this.reportTypes[i].operaType
                                break
                            }
                        }

                        let url= this.headmasterReportCustomGenerateReportUrl;
                        let data = {
                            deptId: this.form.deptId,
                            gradeNames: gradeNames,
                            operaType: operaType,
                            beginDate: this.form.beginDate,
                            endDate: this.form.endDate
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading = true
                        this.loadingText = "生成报告过程时间可能会比较长，请耐心等待"
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.reportUrl = res.data;
                                console.log('响应报告URL', this.reportUrl)
                                this.form.buttonType = 2
                                this.$commonFn.showTip(res.message,1);
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading = false
                        }, (err) => {
                            console.log(err);
                            this.loading = false
                        });
                    }
               });
            },
            // 下载报告
            async download(){
                const link = document.createElement('a');
                link.href = this.reportUrl;
                link.download = '我的文件.pdf'; // 指定下载文件名
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/headMaster/customReport.vue